import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const MulticityHome = () => {
  const navigate = useNavigate();
  useEffect(() => {
    if (localStorage.getItem("compiauthtoken")) {
    } else {
      navigate("/admin/login");
    }
    // eslint-disable-next-line
  }, []);
  return (
    <div className="container-fluid">
      <div className="row my-3">
        <div className="col-sm-4">
          <div
            className="card"
            onClick={() => navigate("/admin/multicity/Bengaluru")}
          >
            <div className="card-body">
              <h5 className="card-title">Bengaluru</h5>
            </div>
          </div>
        </div>
        <div className="col-sm-4">
          <div
            className="card"
            onClick={() => navigate("/admin/multicity/Jaipur")}
          >
            <div className="card-body">
              <h5 className="card-title">Jaipur</h5>
            </div>
          </div>
        </div>
        <div className="col-sm-4">
          <div
            className="card"
            onClick={() => navigate("/admin/multicity/Delhi")}
          >
            <div className="card-body">
              <h5 className="card-title">Delhi</h5>
            </div>
          </div>
        </div>
      </div>
      <div className="row my-3">
        <div className="col-sm-4">
          <div
            className="card"
            onClick={() => navigate("/admin/multicity/Pune")}
          >
            <div className="card-body">
              <h5 className="card-title">Pune</h5>
            </div>
          </div>
        </div>
        <div className="col-sm-4">
          <div
            className="card"
            onClick={() => navigate("/admin/multicity/Mumbai")}
          >
            <div className="card-body">
              <h5 className="card-title">Mumbai</h5>
            </div>
          </div>
        </div>
        <div className="col-sm-4">
          <div
            className="card"
            onClick={() => navigate("/admin/multicity/Gwalior")}
          >
            <div className="card-body">
              <h5 className="card-title">Gwalior</h5>
            </div>
          </div>
        </div>
      </div>
      <div className="row my-3">
        <div className="col-sm-4">
          <div
            className="card"
            onClick={() => navigate("/admin/multicity/Thrissur")}
          >
            <div className="card-body">
              <h5 className="card-title">Thrissur</h5>
            </div>
          </div>
        </div>
        <div className="col-sm-4">
          <div
            className="card"
            onClick={() => navigate("/admin/multicity/Hyderabad")}
          >
            <div className="card-body">
              <h5 className="card-title">Hyderabad</h5>
            </div>
          </div>
        </div>
        <div className="col-sm-4">
          <div
            className="card"
            onClick={() => navigate("/admin/multicity/Kurukshetra")}
          >
            <div className="card-body">
              <h5 className="card-title">Kurukshetra</h5>
            </div>
          </div>
        </div>
      </div>
      <div className="row my-3">
        <div className="col-sm-4">
          <div
            className="card"
            onClick={() => navigate("/admin/multicity/Nagpur")}
          >
            <div className="card-body">
              <h5 className="card-title">Nagpur</h5>
            </div>
          </div>
        </div>
        <div className="col-sm-4">
          <div
            className="card"
            onClick={() => navigate("/admin/multicity/Chandigarh")}
          >
            <div className="card-body">
              <h5 className="card-title">Chandigarh</h5>
            </div>
          </div>
        </div>
        <div className="col-sm-4">
          <div
            className="card"
            onClick={() => navigate("/admin/multicity/Chhattisgarhr")}
          >
            <div className="card-body">
              <h5 className="card-title">Chhattisgarh</h5>
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-sm-4">
          <div
            className="card"
            onClick={() => navigate("/admin/multicity/Ropar")}
          >
            <div className="card-body">
              <h5 className="card-title">Ropar</h5>
            </div>
          </div>
        </div>
        <div className="col-sm-4">
          <div
            className="card"
            onClick={() => navigate("/admin/multicity/Puducherry")}
          >
            <div className="card-body">
              <h5 className="card-title">Puducherry</h5>
            </div>
          </div>
        </div>
      </div>
      <div className="row my-3">
        <div className="col-sm-4"></div>
        <div className="col-sm-4">
          <div
            className="card"
            onClick={() => navigate("/admin/multicity/Bhagalpur")}
          >
            <div className="card-body">
              <h5 className="card-title">Bhagalpur</h5>
            </div>
          </div>
        </div>
        <div className="col-sm-4"></div>
      </div>
    </div>
  );
};

export default MulticityHome;
